module.exports = __webpack_public_path__ + "assets/images/book_b01de05dd4d7fe9cc34424967c43c8cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/locales/nordeste/book.png
// module id = 206
// module chunks = 0